import React from "react";
import Skeleton from "@mui/material/Skeleton";
import {
  ProjectCard,
  ProjectInfoLeft,
  ProjectInfoRight,
  ProjectCircle,
  FundraisingBarContainer,
} from "./Project.styles";

export const ProjectSkeletonCard: React.FC = () => (
  <ProjectCard>
    <ProjectInfoLeft>
      <ProjectCircle />
      <div style={{ marginLeft: 8, width: "100%" }}>
        <Skeleton variant="text" width="40%" height={20} />
        <Skeleton variant="text" width="30%" height={16} />
      </div>
    </ProjectInfoLeft>

    <ProjectInfoRight>
      <div style={{ flex: 1 }}>
        <Skeleton variant="text" width="60%" height={18} />
        <FundraisingBarContainer>
          <Skeleton variant="rectangular" width="100%" height="100%" />
        </FundraisingBarContainer>
        <Skeleton variant="text" width={25} height={16} />
      </div>
      <Skeleton
        variant="circular"
        width={24}
        height={24}
        style={{ marginLeft: "10px" }}
      />
    </ProjectInfoRight>
  </ProjectCard>
);
